import { UserRolesEnumChoice } from '@/shared';

export const AVAILABLE_ROLES_ACTIONS = [
  UserRolesEnumChoice.SUPERVISOR,
  UserRolesEnumChoice.AGENTE,
  UserRolesEnumChoice.OBSERVADOR,
];
